import { api } from './client';

export interface BackendRegionManager {
  _id: string;
  fullName: string;
  phone: string;
}

export interface BackendRegionHtxAssignment {
  _id: string;
  managerUserId: string;
  htxId: string;
  status: 'PENDING' | 'APPROVED' | 'REJECTED';
  active: boolean;
  attachmentFileId?: string;
  rejectionReason?: string;
  createdAt?: string;
  htx?: { _id: string; name: string; code: string } | null;
}

/** Roster of Vùng trồng (Regional Manager) accounts an HTX can address a join
 * request to — open to any authenticated role, no sensitive data beyond name/phone. */
export async function listRegionManagers(): Promise<{ items: BackendRegionManager[] }> {
  return api.get<{ items: BackendRegionManager[] }>('/region/managers');
}

export interface MyRegionAssignment {
  status: 'PENDING' | 'APPROVED' | 'REJECTED';
  manager: { id: string; fullName?: string; phone: string } | null;
  rejectionReason?: string;
  requestedAt: string;
}

/** The calling HTX's own current assignment — `null` if it has never
 * requested one. Feedback 08 C3: this page used to have no backend read of
 * its own status at all, only ever showing the outcome of a submission made
 * in the same session — a reload (or a different device) lost it entirely. */
export async function getMyRegionAssignment(): Promise<MyRegionAssignment | null> {
  return api.get<MyRegionAssignment | null>('/region/my-assignment');
}

/** HTX's own "xin gia nhập Vùng trồng" — always on behalf of the caller's own
 * cooperative, server-derived from the JWT, never a client-supplied htxId. */
export async function requestJoinRegion(managerUserId: string, attachmentFileId?: string): Promise<BackendRegionHtxAssignment> {
  return api.post<BackendRegionHtxAssignment>('/region/join-requests', { managerUserId, attachmentFileId });
}

/** The calling Vùng trồng's own pending "Yêu cầu tham gia" queue. */
export async function listMyJoinRequests(): Promise<BackendRegionHtxAssignment[]> {
  return api.get<BackendRegionHtxAssignment[]>('/region/join-requests/mine');
}

export async function decideJoinRequest(id: string, decision: 'APPROVE' | 'REJECT', rejectionReason?: string): Promise<BackendRegionHtxAssignment> {
  return api.post<BackendRegionHtxAssignment>(`/region/join-requests/${id}/decide`, { decision, rejectionReason });
}

export interface CreateHtxAsRegionManagerPayload {
  name: string;
  code: string;
  address?: string;
}

/** A Vùng trồng creating an HTX directly in its own scope — auto-assigned to the
 * creator, no separate join-request needed for an HTX it just created itself. */
export async function createHtxAsRegionManager(payload: CreateHtxAsRegionManagerPayload) {
  return api.post<{ _id: string; name: string; code: string }>('/region/htxs', payload);
}
